const forms = {
  init() {
  },

};

forms.init();
